import { fromJS } from "immutable";

import { pendingSaveActions } from "actions/pendingSaveActions.js";
import { quantityGridActions } from "actions/quantityGridActions.js";
import { qtyGridActions } from "actions/StockModal/qtyGridActions.js";

// Tracks how many quantity/price saves are currently in flight (across the
// SparePart grid, the regular quantity grid and the stock-model quantity
// grid), so checkout can wait for them to settle instead of submitting
// whatever total is loaded so far.
const initialState = fromJS({
  count: 0
});

export default (state = initialState, action) => {
  switch (action.type) {
    case pendingSaveActions.start:
    case quantityGridActions.requestUpdate:
    case qtyGridActions.requestUpdateQty:
      return state.set("count", state.get("count") + 1);
    case pendingSaveActions.finish:
    case quantityGridActions.updateSuccess:
    case quantityGridActions.updateFailure:
    case qtyGridActions.updateQtySuccess:
    case qtyGridActions.updateQtyFailure:
      return state.set("count", Math.max(0, state.get("count") - 1));
    case pendingSaveActions.reset:
      return initialState;
    default:
      return state;
  }
};
